<template>
    <transition name="modal">
        <div @click="$emit('user-closed-modal')" class="modal-mask">
            <div class="modal-wrapper">
                <div @click.stop class="modal-container">
                    <div class="modal-body">
                        <button @click="$emit('user-closed-modal')" class="c-close  c-close--absolute">&times;</button>
                        <slot></slot>
                        <div v-if="hasButtonNow" class="u-margin-bottom-small"></div>
                        <div v-if="hasButtonNow" class="u-text-center">
                            <button class="c-btn  c-btn--default  u-text-small"
                                    v-if="history.length > 1" @click="history.back()">
                                ← 뒤로
                            </button>

                            <button class="c-btn  c-btn--default  u-text-small"
                                    @click="$emit('user-closed-modal')">
                                닫기
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "Modal",
        data() {
            return {
                history: window.history,
                hasButtonNow: true
            }
        },
        props: ['hasButton'],
        mounted() {
            if (this.hasButton === undefined) {
                this.hasButtonNow = true;
            } else {
                this.hasButtonNow = this.hasButton;
            }
        }
    }
</script>
